// Cómo se pinta la ignición y la velocidad de una unidad en la tarjeta del mapa.
//
// "offline" lo decide el store cuando la unidad lleva más de 60 min sin
// reportar (OFFLINE_THRESHOLD_MS en vehiclesSocketStore). En ese caso
// speed/engine_status son la última lectura, no la actual: el 5-oct-2026, en
// dev, 5 de 10 unidades de una compañía contaban como "Sin Datos" en el
// contador mientras su tarjeta decía "Encendido" en verde con un dato de hace
// 2 h. Una unidad sin reportar se muestra sin datos, igual que el contador; el
// último valor conocido no se pierde, va al tooltip.

export type EngineTone = "on" | "off" | "unknown" | "noData";

export interface EngineReading {
  tone: EngineTone;
  // Lo último que dijo el equipo (sin importar su antigüedad); null si nunca dijo nada.
  lastKnownOn: boolean | null;
}

const readRaw = (
  speed: number | null | undefined,
  status: string,
  engineStatus: number | null | undefined,
): EngineTone => {
  if (speed != null && speed > 0) return "on";
  // "driving" sin velocidad = movimiento real por coordenadas (>20 m).
  if (status === "driving") return "on";
  if (engineStatus == null) return "noData";
  if (engineStatus === 1 || engineStatus === 2 || engineStatus === 3) return "on";
  if (engineStatus === 4 || engineStatus === 5) return "off";
  return "unknown";
};

export const readEngine = (
  speed: number | null | undefined,
  status: string,
  engineStatus: number | null | undefined,
): EngineReading => {
  const raw = readRaw(speed, status, engineStatus);
  const lastKnownOn = raw === "on" ? true : raw === "off" ? false : null;
  return { tone: status === "offline" ? "noData" : raw, lastKnownOn };
};

// null = no hay velocidad vigente que mostrar ("Sin datos").
// El v4-edge OMITE speed=0: en una unidad detenida o en ralentí un speed null
// significa 0 km/h, no "sin dato" (la ficha decía "Ralentí · Sin datos").
export const liveSpeedKmh = (
  speed: number | null | undefined,
  status: string,
): number | null => {
  if (status === "offline") return null;
  if (speed == null) return status === "stopped" || status === "ralenti" ? 0 : null;
  return speed;
};
